module.exports = __webpack_public_path__ + "img/tentang-amalan.2c055cce.svg";